import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { GameProviderPosition } from '@core/models/game-provider-position.model';

@Injectable()
export class GameProviderPositionEntityService extends EntityCollectionServiceBase<GameProviderPosition> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('GameProviderPosition', serviceElementsFactory);
  }
}